<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <!-- Botón de retroceso -->
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        
        <!-- Fila para título y botón de filtro en pantallas grandes -->
        <v-row align="center" class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">
          <v-col v-if="!$vuetify.breakpoint.xs" class="d-flex" style="color: white;">
            {{ title }}
          </v-col>
          <!-- Título centrado en pantallas pequeñas -->
          <v-col v-if="$vuetify.breakpoint.xs" class="d-flex justify-center" style="color: white;font-size: 2rem;">
            <div class="text-center">{{ title }}</div>
          </v-col>
        </v-row>

        <!-- Botón de filtro (Ver todas / Ver solo favoritas) en pantallas pequeñas -->
        <v-row v-if="$vuetify.breakpoint.xs">
          <v-col class="d-flex justify-center">
            <v-btn
              @click="getall()"
              dark
              depressed
              color="success"
              v-if="!show_alls"
              style="width: 100%; margin-bottom: 10px;"
            >
              Ver todas
            </v-btn>
            <v-btn
              @click="getOnlyFavs()"
              dark
              depressed
              color="info"
              v-if="show_alls"
              style="width: 100%; margin-bottom: 10px;"
            >
              Ver solo favoritas
            </v-btn>
          </v-col>
        </v-row>

        <!-- Botón de filtro (Ver todas / Ver solo favoritas) en pantallas grandes -->
        <v-row v-if="!$vuetify.breakpoint.xs">
          <v-col class="d-flex justify-end">
            <v-btn
              @click="getall()"
              dark
              depressed
              color="success"
              v-if="!show_alls"
              class="mb-2"
            >
              Ver todas
            </v-btn>
            <v-btn
              @click="getOnlyFavs()"
              dark
              depressed
              color="info"
              v-if="show_alls"
              class="mb-2"
            >
              Ver solo favoritas
            </v-btn>
          </v-col>
        </v-row>

        <v-expansion-panels v-if="$vuetify.breakpoint.xs">
  <v-expansion-panel
    v-for="(materiaData, materiaKey) in filteredMaterias"
    :key="materiaKey"
    class="mt-1 rounded"
  >
    <v-expansion-panel-header
      class="pb-7"
      style="background-color: #e0e0e0; border-radius: 8px;"
    >
      {{ materiaData.materia }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row style="margin-top: 10px;">
        <v-col cols="12">
          <v-btn
            v-if="materiaData.ruta"
            @click="linkVideo(materiaData.ruta)"
            small
            class="info--text text-decoration-underline font-weight-regular"
            depressed
            text
            color="info"
          >
            Ver Contenido Asincrónico
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-btn
            v-if="materiaData.google_drive"
            :href="materiaData.google_drive"
            target="_blank"
            small
            class="info--text text-decoration-underline font-weight-regular"
            depressed
            text
            color="info"
          >
            Ver Google Drive
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-btn
            v-if="materiaData.forum_categoria"
            :href="'/foro/'+materiaData.forum_categoria"
            target="_blank"
            small
            class="info--text text-decoration-underline font-weight-regular"
            depressed
            text
            color="info"
          >
            Ver Foro
          </v-btn>
        </v-col>
        <v-col cols="12">
          <!-- Botón de Favoritos en Acordeón (estrella) -->
          <v-btn
            @click="materiaData.visible == 1 ? hide2(materiaData.inscripcion_materia) : show2(materiaData.inscripcion_materia)"
            :style="{
              backgroundColor: materiaData.visible == 1 ? 'green' : 'white',
              color: materiaData.visible == 1 ? 'white' : 'green',
              border: '1px solid green'
            }"
            small
            class="font-weight-regular"
            depressed
          >
            {{ materiaData.visible == 1 ? 'Favoritos' : 'Añadir a Favoritos' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-expansion-panels>


        <!-- Tabla para pantallas grandes -->
        <v-simple-table v-if="!$vuetify.breakpoint.xs">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Materia
                </th>
                <th class="text-center">
                  Contenido Asincrónico (Grabado)
                </th>
                <th class="text-center">
                  Google Drive
                </th>
                <th class="text-center">
                  Foro
                </th>
                <th class="text-left">
                  Favoritas
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(materiaData, materiaKey) in filteredMaterias" :key="materiaKey">
                <td>
                  {{ materiaData.materia }}
                </td>
                <td align="center">
                  <v-btn v-if="materiaData.ruta" @click="linkVideo(materiaData.ruta)" small class="info--text text-decoration-underline font-weight-regular" depressed text color="info">
                    Ver Aquí
                  </v-btn>
                  <div v-else>
                    <b class="text-center">Sin contenido aún</b>
                  </div>
                </td>
                <td align="center">
                  <v-btn v-if="materiaData.google_drive != null" :href="materiaData.google_drive" target="_blank" small class="info--text text-decoration-underline font-weight-regular" depressed text color="info">
                    Ver Aquí
                  </v-btn>
                  <div v-else>
                    <b class="text-center">Sin contenido aún</b>
                  </div>
                </td>
                <td align="center">
                  <v-btn v-if="materiaData.forum_categoria != null" :href="'/foro/'+ materiaData.forum_categoria" target="_blank" small class="info--text text-decoration-underline font-weight-regular" depressed text color="info">
                    Ver Aquí
                  </v-btn>
                  <div v-else>
                    <b class="text-center">Sin contenido aún</b>
                  </div>
                </td>
                <td>
                  <v-btn v-if="materiaData.visible == 1" @click="hide2(materiaData.inscripcion_materia)" title="Ocultar" depressed text color="success">
                    <v-icon dark>mdi-star</v-icon>
                  </v-btn>
                  <v-btn v-else @click="show2(materiaData.inscripcion_materia)" title="Mostrar" depressed text color="success">
                    <v-icon dark>mdi-star-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>


<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "MisMaterias",
  components: {
    CardIeaAppMain
  },

  data: () => ({
    title: "Mis materias",
    materias: [],
    show_alls: false,
    ganoBadge: false,
    imgBadge: "bronce",
    dias: 3
  }),
  computed: {
    filteredMaterias() {
      if (this.show_alls) {
        return this.materias;
      } else {
        return this.materias.filter(materia => materia.visible == 1);
      }
    },
    tieneBadge1() {
      return this.$store.getters.tieneBadge1;
    },
    tieneBadge2() {
      return this.$store.getters.tieneBadge2;
    },
    tieneBadge3() {
      return this.$store.getters.tieneBadge3;
    },
    porcentaje1() {
      return this.$store.getters.porcentaje1;
    },
    porcentaje2() {
      return this.$store.getters.porcentaje2;
    },
    porcentaje3() {
      return this.$store.getters.porcentaje3;
    },
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    async logPerseverancia() {
      await this.$API
        .get({
          url: "alumno/setperseverancia"
        })
        .then(res => {
          if (!res.tieneBadge1) {
            if (res.registraBadge1) {
              this.imgBadge = "bronce2";
              this.$store.commit("tieneBadge1", res.registraBadge1);
              this.$confetti.start();
              this.ganoBadge = true;
              this.dias = 3;
              setTimeout(() => {
                this.$confetti.stop();
              }, 3000);
            }
          }

          if (!res.tieneBadge2) {
            if (res.registraBadge2) {
              this.imgBadge = "plata2";

              this.$store.commit("tieneBadge2", res.registraBadge2);
              this.$confetti.start();
              this.ganoBadge = true;
              this.dias = 5;
              setTimeout(() => {
                this.$confetti.stop();
              }, 3000);
            }
          }

          if (!res.tieneBadge3) {
            if (res.registraBadge3) {
              this.imgBadge = "oro2";
              this.$store.commit("tieneBadge3", res.registraBadge3);
              this.$confetti.start();
              this.ganoBadge = true;
              this.dias = 10;
              setTimeout(() => {
                this.$confetti.stop();
              }, 3000);
            }
          }
          this.$store.commit("porcentaje1", res.porcentaje1);
          this.$store.commit("porcentaje2", res.porcentaje2);
          this.$store.commit("porcentaje3", res.porcentaje3);
        });
    },
    linkMeet(code) {
      return "https://meet.google.com/" + code;
    },

    async hide(id) {
      this.materias = null;
      await this.$API
        .post({
          url: "materia/setvisible",
          data: {
            id: id,
            visible: 0
          }
        })
        .then(() => {
          this.getallData();
        });
    },

    async show(id) {
      this.materias = null;
      await this.$API
        .post({
          url: "materia/setvisible",
          data: {
            id: id,
            visible: 1
          }
        })
        .then(() => {
          this.getallData();
        });
    },

    async show2(id) {
      await this.$API
        .post({
          url: "materia/setvisible",
          data: {
            id: id,
            visible: 1
          }
        })
        .then(() => {
          this.getMaterias();
        });
    },

    async hide2(id) {
      await this.$API
        .post({
          url: "materia/setvisible",
          data: {
            id: id,
            visible: 0
          }
        })
        .then(() => {
          this.getMaterias();
        });
    },
    getall() {
      this.show_alls = true;
    },
    getOnlyFavs() {
      this.show_alls = false;
      this.getMaterias()
    },

    async getallData() {
      this.$API
        .get({
          url: "materias",
          data: {}
        })
        .then(res => {
          const arr = [];
          for (const i in res) { arr.push(res[i]) }
          this.materias = arr;
        });
    },
    linkVideo(ruta) {
      // Reemplaza la base de la URL
      const nuevaRuta = ruta.replace('https://public.sistemaiea.com', 'https://public.terminalasecundaria.ar');
      
      // Abre la nueva URL
      window.open(nuevaRuta);
    },

    getMaterias() {
      if (
        this.$store.getters.user.borrado == 1 ||
        this.$store.getters.user.alumno_mora == true
      ) {
        this.$router.push({
          name: "Home"
        });
      }
      this.$API
        .get({
          url: "materias",
          data: {}
        })
        .then(res => {
        const arr = [];
        for (const i in res) { arr.push(res[i]) }
        this.materias = arr;
        });
    }
  },

  mounted() {
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true
    ) {
      this.$router.push({
        name: "Home"
      });
    }
    this.$API
      .get({
        url: "materias",
        data: {}
      })
      .then(res => {
        const arr = [];
        for (const i in res) { arr.push(res[i]) }
        this.materias = arr;
      });
  }
};
</script>
<style scoped>
::v-deep .v-icon__svg {
    height: 24px;
    width: 24px;
    fill: rgb(127, 124, 124);
}
</style>